<template>

  <b-row class="justify-content-center">
    <template v-for="option in options">
      <b-col
        xl="3" lg="4" md="4" sm="6"
        class="pb-4"
        v-if="
          (!option.roles && !option.permissions) ||
          (option.roles && option.roles.length && hasRole(option.roles)) ||
          (option.permissions && option.permissions.length && hasAnyOfPermissions(option.permissions))"
      >
        <AppPageOptionBox
          :icon="option.icon"
          :text="option.text"
          @onClick="goToRoute(option.routeName)"
        />
      </b-col>
    </template>
  </b-row>

</template>

<script>
  import AppSection from "../../../../../components/common/sections/AppSection";
  import AppPageOptionBox from "../../../../../components/common/utils/AppPageOptionBox";
  import smsMenu from "../smsMenu";
  export default {
    name: "index",
    components: {AppPageOptionBox, AppSection},
    data() {
      return {
        options: smsMenu
      }
    },
    methods: {
      goToRoute(routeName) {
        this.$router.push({name: routeName});
      }
    }
  }
</script>

<style scoped>

</style>
